import axios from 'axios'
import Stripe from 'stripe'
import { getBffBaseUrl } from '@/utils/environment-variables'
import { logger } from '@/utils/logging'

/*
 * Stripe API documentation: https://docs.stripe.com/api?lang=node
 *
 * NOTE: Error objects returned by the SDK are not standard Javascript Errors. They have several properties for context.
 * See https://docs.stripe.com/api/errors?lang=node
 */

/**
 * The PromotionCode object ultimately comes from Stripe.
 * We cache these on the backend to prevent getting rate limited by Stripe.
 * Certain properties, such as `times_redeemed`, should be assumed to be out of date if `isFromCache` is true.
 */
export interface PromotionCode extends Stripe.PromotionCode {
  isFromCache?: boolean
}

/**
 * Returns a promotion code if a valid customer facing code was provided. Otherwise returns undefined.
 * @param code
 */
export async function findPromotionCodeByCustomerFacingCode(code: string): Promise<PromotionCode | undefined> {
  try {
    const response = await axios.get(`${getBffBaseUrl()}/promotions/by-customer-code/${code}`)
    const promotionCode = response.data.promotionCode as PromotionCode | undefined
    if (promotionCode) {
      logger().debug('Successfully found a Stripe Promotion Code by customer facing code.', { code })
    } else {
      logger().warn('Failed to find a Stripe Promotion Code by customer facing code.', { code })
    }
    return promotionCode
  } catch (err) {
    logger().error('An error occurred while attempting to find a Stripe Promotion Code by customer facing code.', {
      code,
      err,
    })
  }
}
